import type React from 'react';

import Checkbox, { type CheckboxProps } from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';

import { useStyles } from './styles';

export interface MuiCheckboxProps {
  field?: {
    name: string;
    value: boolean;
    onChange(): void;
  };
  label: React.ReactNode;
  handleChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  checked: boolean;
  checkboxProps?: CheckboxProps;
}

const MuiCheckbox: React.FC<React.PropsWithChildren<MuiCheckboxProps>> = ({
  field,
  handleChange,
  checked,
  checkboxProps,
  ...props
}) => {
  const { classes } = useStyles();

  return (
    <FormControlLabel
      classes={{ label: classes.label }}
      control={
        <Checkbox
          {...checkboxProps}
          checked={field?.value ? field?.value : checked}
          color="primary"
          onChange={handleChange}
          {...field}
        />
      }
      {...props}
    />
  );
};

export default MuiCheckbox;
